import { spawn, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

export type TakeAction<T extends { type: string }, U> = Extract<T, { type: U }>;

function* sagaToRespawn(saga, ...args): SagaIterator<void> {
    while (true) {
        try {
            yield call(saga, ...args);
            break;
        } catch (err) {
            console.error(err);
        }
    }
}

export const respawn = (saga, ...args: unknown[]) => spawn(sagaToRespawn, saga, ...args);

export const onErrorMonitor = (handler) => (_, error) => {
    handler(error);
};

export const watcherActionErrorMessage = (watcherName: string, actionType: string | string[]): string =>
    `Unable execute saga watcher "${watcherName}" watching "${actionType}" action`;

export const watcherEventErrorMessage = (watcherName: string, eventType: string): string =>
    `Unable execute saga watcher "${watcherName}" watching "${eventType}" event`;

export const sagaErrorMessage = (sagaName: string, args?: Record<string, unknown>): string =>
    `Unable to execute saga "${sagaName}" ${
        args
            ? `with params: ${Object.entries(args).reduce(
                  (acc, [name, value]) => `${acc}, ${name}: ${value}`,
                  ''
              )}`
            : ''
    }`;
